import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"
import { format_thousands, round_with_spaces } from "../../../utils/functions"
import stats_font_sizes from "../../../configs/stats_font_sizes.json"
import theme_colors from "../../../configs/theme_colors.json"

const bar_color_1 = theme_colors.uninsured_yellow
const bar_color_2 = theme_colors.insured_yellow
const bar_color_3 = theme_colors.ndoh_yellow
const bar_color_4 = theme_colors.sa_brown_2

export function BarChartPopulation({
  data: { served, unserved, population, uninsured },
}) {
  const new_data = [
    {
      served: served > 0 ? served : 0,
      unserved: unserved > 0 ? unserved : 0,
      population: population > 0 ? population : 0,
      uninsured: uninsured > 0 ? uninsured : 0,
    },
  ]

  const CustomLegendServed = () => {
    return (
      <div style={{ fontSize: 13 }}>
        <span style={{ color: bar_color_1, paddingLeft: 10 }}>■</span> Served
        pop.
        <span style={{ color: bar_color_2, paddingLeft: 10 }}>■</span> Unserved
        pop.
        <br /> <span style={{ color: bar_color_3, paddingLeft: 10 }}>
          ■
        </span>{" "}
        Uninsured pop.
        <span style={{ color: bar_color_4, paddingLeft: 10 }}>■</span> Total
        pop.
      </div>
    )
  }

  function CustomTooltipServed({ payload, active }) {
    if (active) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            fontSize: stats_font_sizes.tooltip_font_size,
            padding: 4,
            border: "black",
            boxShadow: "4px 6px 3px rgba(0, 0, 0, 0.2)",
          }}
        >
          <p style={{ padding: 0, margin: 0 }}>{`Served: ${round_with_spaces(
            payload[0].value,
          )} people`}</p>
          <p style={{ padding: 0, margin: 0 }}>{`Unserved: ${round_with_spaces(
            payload[1].value,
          )} people`}</p>
          <p style={{ padding: 0, margin: 0 }}>{`Uninsured: ${round_with_spaces(
            payload[2].value,
          )} people`}</p>
          <p
            style={{ padding: 0, margin: 0 }}
          >{`Population: ${round_with_spaces(payload[3].value)} people`}</p>
        </div>
      )
    }

    return null
  }
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={new_data} margin={{ left: -8 }} barGap={10}>
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          horizontal={true}
        />
        <XAxis
          dataKey="name"
          fontSize={stats_font_sizes.x_axis_label_font_size}
          label={false}
        />
        <YAxis
          fontSize={stats_font_sizes.y_axis_label_font_size}
          label={{
            value: "Population",
            style: { textAnchor: "middle" },
            angle: -90,
            position: "left",
            offset: -20,
          }}
          tickFormatter={(tick) => format_thousands(tick)}
        />
        <Tooltip content={<CustomTooltipServed />} />
        <Legend content={<CustomLegendServed />} />
        <Bar dataKey="served" fill={bar_color_1} />
        <Bar dataKey="unserved" fill={bar_color_2} />
        <Bar dataKey="uninsured" fill={bar_color_3} />
        <Bar dataKey="population" fill={bar_color_4} />
      </BarChart>
    </ResponsiveContainer>
  )
}
